import React, { useState } from 'react';
import { Play, X } from 'lucide-react';

const VideoSection = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <section data-testid="video-section" className="relative py-20 md:py-32 bg-cream overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-dwarfpony text-sm font-semibold tracking-wider uppercase mb-4">
            Experience
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-deepwalnut mb-6">
            Experience the <span className="text-richolive">Thrill</span> of Competition
          </h2>
          <p className="text-heavyrain text-lg max-w-2xl mx-auto">
            Watch our Team India's incredible journey at FIRST Global
          </p>
        </div>

        {/* Video Container */}
        <div className="relative max-w-4xl mx-auto">
          <div className="relative aspect-video rounded-2xl overflow-hidden bg-cream-dark border border-pragmatic/30 shadow-2xl">
            {isPlaying ? (
              <div className="relative w-full h-full">
                <iframe
                  src="https://www.youtube.com/embed/I1YgLCUb3zI?start=73&autoplay=1"
                  title="FIRST Global Team India"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  className="absolute inset-0 w-full h-full"
                />
                <button
                  onClick={() => setIsPlaying(false)}
                  className="absolute top-4 right-4 w-10 h-10 bg-cream/90 backdrop-blur-md rounded-full flex items-center justify-center text-deepwalnut hover:bg-cream transition-colors z-10 shadow-lg"
                >
                  <X size={20} />
                </button>
              </div>
            ) : (
              <>
                <img
                  src="/assets/images/home-video-cover.jpg"
                  alt="Team India Competition"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-midnight/30" />

                {/* Play Button */}
                <button
                  onClick={() => setIsPlaying(true)}
                  className="absolute inset-0 flex items-center justify-center group"
                >
                  <div className="relative">
                    <div className="absolute inset-0 bg-dwarfpony/30 rounded-full animate-ping" />
                    <div className="relative w-20 h-20 md:w-24 md:h-24 bg-dwarfpony rounded-full flex items-center justify-center shadow-xl shadow-dwarfpony/30 group-hover:scale-110 transition-transform">
                      <Play size={32} className="text-white ml-1" fill="white" />
                    </div>
                  </div>
                </button>

                {/* Video Title */}
                <div className="absolute bottom-6 left-6 right-6">
                  <p className="text-white font-bold text-xl">Team India Journey</p>
                  <p className="text-pragmatic">Watch our students compete at the world stage</p>
                </div>
              </>
            )}
          </div>

          {/* Decorative Elements */}
          <div className="absolute -top-4 -left-4 w-24 h-24 border-l-2 border-t-2 border-dwarfpony/50 rounded-tl-2xl" />
          <div className="absolute -bottom-4 -right-4 w-24 h-24 border-r-2 border-b-2 border-richolive/50 rounded-br-2xl" />
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
